import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { healthTitle, healthList0, shopInHealth, healthList1 },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip id="200146" type="struct" title="健康标题" groupName="健康" content={healthTitle}>
                    <NewsTitle size="short" />
                </Chip>
                <Chip
                    id="225762"
                    type="recommend"
                    title="健康列表1"
                    groupName="健康"
                    content={healthList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="short" />
                </Chip>
                <NewsList size="short" content={shopInHealth} />
                <Chip
                    id="225763"
                    type="recommend"
                    title="健康列表2"
                    groupName="健康"
                    content={healthList1}
                    translate="handleNewsData">
                    <NewsList size="short" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
